import Nutshell from '../Nutshell';

export default class Plugin {

    static pluginName = this.constructor.name;

    static getDefaults() {
        return {};
    }

    static getName() {
        return this.constructor.pluginName;
    }

    constructor(options) {

        let name = this.constructor.getName();
        this.options = ( Nutshell.options[name] ) ?  { ...Nutshell.options[name] } : {};

        if ( options ) {
            this.options = { ...this.options, ...options };
        }
    }

}
